import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';


const LazyAudioTrackContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "StandaloneAudioTrack" */
    './components/StandaloneAudioTrack'
  ),
  delay: 1000,
  // eslint-disable-next-line
  loading: (props) => (props.pastDelay ? <LoadingSpinner /> : null)
});

const AudioTrackRoute = (
  <Route
    path="/audio-tracks/:slug"
    component={LazyAudioTrackContainer}
  />
);

export default AudioTrackRoute;
